import React from 'react';
import { Card, CardContent, CardHeader, Grid, CircularProgress, Checkbox, Radio } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const ColoredCheckbox = withStyles({
    root: {
      color: 'var(--jmi-green)',
      '&$checked': {},
    },
    checked: {},
  })(props => <Checkbox color="default" {...props} />);
  export default ColoredCheckbox;